import { type ReactElement } from "react";

import { LoadingContainer as StyledLoadingContainer } from "src/components/Dashboard/styles";
import {
  Dot1,
  Dot2,
  Dot3,
  Loader as StyledLoader,
} from "src/components/ButtonLoader/styles";

const Loader = (): ReactElement => (
  <StyledLoadingContainer>
    <StyledLoader>
      <Dot1 />
      <Dot2 />
      <Dot3 />
    </StyledLoader>
  </StyledLoadingContainer>
);

export default Loader;
